exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".titleComponent{text-align:center;text-transform:uppercase}.titleComponent__text{display:inline-block;line-height:38px;color:#484848;font-size:20px;border-top:1px solid #444;border-bottom:1px solid #444}.titleComponent__mainText{color:#279cc7;font-weight:900}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3e7ec8a2","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/titleComponent.vue
// module id = 219
// module chunks = 0